export default "__VITE_ASSET__irQ07VLd__ 584w";